import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from '../ProductArchiveStrategy/ReconcileForm.js'
import EditForm from '../ProductArchiveStrategy/EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/productUnarchiveStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class ProductUnarchiveStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

ProductUnarchiveStrategy.title = actions.title
const option = {
  value: 'unarchive_product',
  display: 'Unarchive Products',
  category: 'products',
  Component: ProductUnarchiveStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductUnarchiveStrategy.option = option
